import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import ServicesPage from "./pages/ServicesPage";
import ServiceDetail from "./pages/ServiceDetail";
import ServiceCityPage from "./pages/ServiceCityPage";
import LandingPage from "./pages/LandingPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ServiceAreasPage from "./pages/ServiceAreasPage";
import CityServiceArea from "./pages/CityServiceArea";
import Reviews from "./pages/Reviews";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/services/:serviceSlug/:citySlug" element={<ServiceCityPage />} />
          <Route path="/service-areas" element={<ServiceAreasPage />} />
          <Route path="/service-areas/:slug" element={<CityServiceArea />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/storm-damage-roof-repair-virginia" element={<LandingPage pageKey="storm-damage" />} />
          <Route path="/wind-damage-roof-repair" element={<LandingPage pageKey="wind-damage" />} />
          <Route path="/roofing-contractor-mclean-va" element={<LandingPage pageKey="mclean" />} />
          <Route path="/roofing-contractor-vienna-va" element={<LandingPage pageKey="vienna" />} />
          <Route path="/roof-maintenance" element={<LandingPage pageKey="roof-maintenance" />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
